import { Component, ViewChild } from '@angular/core';
import { DxValidationGroupComponent } from 'devextreme-angular';
import { BaseEntity, BaseState, LoginParams, PasswordRecoveryParams, BaseResponse } from '@base/entities/BaseEntities';
import { BasePageComponent } from '@base/component/BasePageComponent';
import { ServiceBagService, ServiceBagServices } from '@base/component/ServiceBag';
import { SysGlobals } from '@core/framework/sysglobals';
import { RC } from '@core/framework/resources.service';
import { LoginEndpoint } from '@core/endpoints/login.endpoint';

class State extends BaseState {
    Stage: number;
    UserName: string
    Token: string;
    NewPassword1: string;
    NewPassword2: string;

}
@Component({
    providers: ServiceBagServices,
    selector: 'm4u-passwordwelcome',
    templateUrl: './passwordwelcome.component.html',
    styleUrls: ['./passwordwelcome.component.scss']
})
export class PasswordWelcomeComponent extends BasePageComponent<BaseEntity, State>
{
    @ViewChild('validationGroup') protected validationGroup: DxValidationGroupComponent;

    constructor(A: ServiceBagService, private loginEndpoint: LoginEndpoint) {
        super(A, 'ChangePasswordExpiredComponent', LoginParams, State);
        this.BindHandler('IsPasswordsMatch');
        this.BindHandler('IsPasswordComplex');
    }

    //Set initial params
    override OnInitState() {
        this.State.Stage = 2;
        this.State.UserName = this.QueryParams.UserName;
        this.State.Token = this.QueryParams.Token;

        //Set language
        if (this.QueryParams.Language != undefined) {
            SysGlobals.Language = this.QueryParams.Language;
            this.Framework.InitLanguage();
            this.Framework.InitializeDevExpress();
        }
    }


    //Verify the recovery token
    //Upon success, move to the next screen
    OnVerifyRecoveryToken() {
        if (!this.validationGroup.instance.validate().isValid) return;
        var params = new PasswordRecoveryParams;
        params.UserName = this.State.UserName;
        params.Token = this.State.Token;
        params.Language = SysGlobals.Language;
        this.Do(this.loginEndpoint.VerifyRecoveryToken(params), false, () => this.State.Stage = 3);
    }

    //Go back to previous stage
    OnResend() {
        this.InitState();
        this.State.Stage = 1;
    }

    OnCancel() {
        this.Navigate(['system/login']);
    }


    IsPasswordsMatch(): boolean {
        return this.State.NewPassword1 == this.State.NewPassword2;
    }

    //Verifies (server-side) whether password is complex enough
    IsPasswordComplex() {
        return new Promise((resolve, reject) => {
            var params = new LoginParams;
            params.SecureKey = this.State.NewPassword1;
            params.Language = SysGlobals.Language;
            this.Do(this.loginEndpoint.VerifyPasswordComplexity(params), false, () => resolve(true), (response: BaseResponse) => reject(response.ResponseMessage));
        });
    }

    //Make the change. 
    //After making the change, logout and show the login screen
    //Also, reset the stored password
    OnSubmit() {
        if (!this.validationGroup.instance.validate().isValid) return;
        var params = new PasswordRecoveryParams;
        params.UserName = this.State.UserName;
        params.Token = this.State.Token;
        params.Language = SysGlobals.Language;
        params.NewPassword = this.State.NewPassword1;
        this.Do(this.loginEndpoint.ChangePasswordByToken(params), false, () => {
            this.UI.InfoMessage(RC("titlePasswordChanged"));
            //this.A.Session.LogoutAndResetSession();
            this.A.Session.EndSession(() => { this.Navigate(['/system/login'], { Language: SysGlobals.Language }); });
        });
    }

    GetAdditionalTitle() {
        return this.State.Stage === 2 ? this.RC('titleWelcomePassword2') : this.State.Stage === 3 ? this.RC('titleRecoverPassword3') : '';
    }
}
